// extracted by css-extract-rspack-plugin
export default {"heroHeading":"FlexSuite-module__heroHeading__y99K2"};